import { Link as MuiLink, Typography } from '@mui/material'
import { Fragment } from 'react/jsx-runtime'
import { Link } from 'react-router-dom'

import {
  getCampaignEditPath,
  TGoLiveValidationErrorWithStep,
} from '~/features/campaigns/utils'

type TActionErrorsDisplayProps =
  | {
      validationErrors: string[]
      validationErrorsWithSteps?: never
      campaignId?: never
      linkColor?: string
      showLabel?: boolean
    }
  | {
      validationErrors?: never
      validationErrorsWithSteps: TGoLiveValidationErrorWithStep[]
      campaignId?: string
      linkColor?: string
      showLabel?: boolean
    }

export default function ActionErrorsDisplay({
  validationErrors,
  validationErrorsWithSteps,
  campaignId,
  linkColor,
  showLabel = false,
}: TActionErrorsDisplayProps) {
  const getAssistantIdFromFieldPath = (fieldPath?: string) =>
    fieldPath?.match(
      /^sharedCampaignAgentSettings\.([^.]+)\.locationFields\./,
    )?.[1]

  const withSteps =
    validationErrorsWithSteps && validationErrorsWithSteps.length > 0
  const errors: TGoLiveValidationErrorWithStep[] = withSteps
    ? validationErrorsWithSteps
    : (validationErrors ?? []).map((message) => ({ message }))

  return (
    <>
      {showLabel && (
        <Typography
          component="span"
          variant="body2"
          fontWeight={600}
          sx={{ display: 'block' }}
        >
          {errors.length} {errors.length > 1 ? 'items' : 'item'} incomplete:
        </Typography>
      )}
      <Typography component="span" variant="body2" sx={{ display: 'block' }}>
        {errors.map((item, index) => {
          const hasLink = Boolean(campaignId && item.stepId)
          return (
            <Fragment key={`action-error-${index.toString()}`}>
              •{' '}
              {hasLink ? (
                <MuiLink
                  component={Link}
                  variant="body2"
                  to={getCampaignEditPath({
                    id: campaignId!,
                    stepId: item.stepId,
                    assistantId: getAssistantIdFromFieldPath(item.fieldPath),
                    fieldPath: item.fieldPath,
                  })}
                  sx={{
                    cursor: 'pointer',
                    textAlign: 'left',
                    verticalAlign: 'baseline',
                    ...(linkColor != null ? { color: linkColor } : {}),
                    '&:hover': {
                      textDecoration: 'underline',
                      ...(linkColor != null ? { color: linkColor } : {}),
                    },
                  }}
                >
                  {item.friendlyField ?? item.message}
                </MuiLink>
              ) : (
                (item.friendlyField ?? item.message)
              )}
              {index < errors.length - 1 ? <br /> : null}
            </Fragment>
          )
        })}
      </Typography>
    </>
  )
}
